<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList">
      <template slot="self-config">
        <el-form-item label="关联字段" prop="title">
          <el-select v-model="form.download_field" multiple placeholder="关联字段" class="fl w-200 m-r-10" >
            <el-option v-for="option in inputList" :label="option.default.name + '(' + option.default.title + ')'" :value="option.default.field_id" v-if="option.default.type == TYPE_FILE"></el-option>
          </el-select>
        </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import modelConfig from '../../../../config/modelConfig'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          download_field: []
        },
        deleteShow: false,  // 删除分组提示显示标识
        inputList: []  // 控件数组
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              if (res.data.config.download_field) {
                this.form.download_field = res.data.config.download_field
              }
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
          }
        })
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// downloadConfig.vue?446f9c80